import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '@/redux/store'

const userSelector = (state:RootState) => state.user

export const userData = createSelector(userSelector, (userState) => userState.userData)
export const userSettings = createSelector(userSelector, (userState) => userState.userData?.settings)
export const isSeniorUser = createSelector(userSelector, (userState) => userState?.userData?.isSenior)
